/**
* Created by kongwm.kong on 2017/7/21.
*/
<template>
    <div class="layout_n">
        <div class="center_page_wrap">
            <center-tip :tipShow="tipShowFlag"></center-tip>
            <div class="sub-menu-wrap">
                <div :class="{'menu-item': true ,active: baseInfo}" @click="getBase">基本信息</div>
                <div :class="{'menu-item': true ,'active': changePass}" @click="getChange">修改密码</div>
            </div>
            <section v-show="baseInfo" class="base-info">
                <div class="info-item item">
                    <span class="name-tit">公司全称：</span>
                    <span>{{userData!=null ? userData.companyName :''}}</span>
                </div>
                <div class="info-item item">
                    <span class="name-tit">用户名：</span>
                    <span>{{userData!=null ? userData.userName: ''}}</span>
                </div>
                <div class="info-item item">
                    <span class="name-tit">手机号码：</span>
                    <span>{{userData!=null ?userData.phone: ''}}</span>
                    <div class="changePhone" @click="showMobile">更改</div>
                </div>
                <div class="phoneTip item">
                    <span class="span">是否接受短信消息提醒</span>
                   <div class="radio_wrap clearfix" >
                       <div class="radio-item" @click="acceptNot(true)">
                           <div :class="['radio' ,{'active':userData!=null&& userData.acceptNotification}]"><div class="rad"></div></div>
                           <div class="text">是</div>
                       </div>
                       <div class="radio-item" @click="acceptNot(false)">
                           <div :class="['radio' ,{'active': userData!=null&&!userData.acceptNotification}]"><div class="rad"></div></div>
                           <div class="text">否</div>
                       </div>
                   </div>
                </div>
                <!--金斧子产品保证承诺函模板-->
                <div class="up-promise item">
                    <span>承诺函上传</span>
                    <span>产品承诺函请点此链接获取：<a target="_blank" href="https://jfz-stock.oss-cn-hangzhou.aliyuncs.com/common/prod/%E9%87%91%E6%96%A7%E5%AD%90%E4%BA%A7%E5%93%81%E4%BF%9D%E8%AF%81%E6%89%BF%E8%AF%BA%E5%87%BD%E6%A8%A1%E6%9D%BF.docx">产品保证承诺函模板</a></span>
                </div>
                <div class="img-promise item">
                    <img v-show="!promiseImg || promiseImg==null" src="../../assets/img/common/zwt.png" width="100" height="100">
                    <img v-show="promiseImg" :src="promiseImg" width="100" height="100">
                </div>
                <div class="go-up-pro item" v-show="tipShowFlag!=1 && tipShowFlag!=0">
                    <div class="load-wrap">
                        <up-load @showSmallImg="showSmallImg" :isValidSize="false" :color="color"></up-load>
                    </div>
                   格式支持jpeg、jpg、png
                </div>
            </section>
            <section v-show="changePass" class="change-pass">
                <form @submit.prevent="changeNewPass">
                    <div class="filed">
                        <label for="prePass">原密码</label>
                        <div class="input_wrap">
                            <input class="" id="prePass" type="password" v-model="oldPass" v-validate="'required|password'" name="prePass">
                            <div class="err">
                                <span v-show="errors.has('prePass')">{{errors.first('prePass')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="filed">
                        <label for="nowPass">新密码</label>
                        <div class="input_wrap">
                            <input class="" id="nowPass" type="password" v-validate="'required|password'" data-vv-as="密码"  v-model="password" name="password">
                            <div class="err">
                                <span v-show="errors.has('password')">{{errors.first('password')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="filed">
                        <label for="newPass">确认新密码</label>
                        <div class="input_wrap">
                            <input class="" @blur="validPass" id="newPass" type="password" v-validate="'required|password'" data-vv-as="新密码" v-model="newPass" name="newPass">
                            <div class="err">
                                <span v-show="errors.has('newPass')">{{errors.first('newPass')}}</span>
                                <span v-show="!errors.has('newPass')&& showPassFlag">{{showPassMsg}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="btn"><button type="submit">确定</button></div>
                </form>

            </section>
        </div>
        <upload-suc></upload-suc>
        <change-mobile @listenChangeMobile="listenChangeMobile"></change-mobile>
    </div>

</template>
<script>
    import centerTip  from './centerTip';
    import uploadSuc  from '../../components/modal/uploadSuc';
    import changeMobile  from '../../components/modal/changeMobile';
    import upLoad from '../../components/common/upload';

    export default {
        components: {
            centerTip ,
            uploadSuc,
            changeMobile,
            upLoad
        },
        data () {
            return {
                userData:{
                    phone: '',
                },
                baseInfo: true,
                changePass : false,
                promiseImg: '',
                password: null,
                newPass: null,
                color: '$btn408',
                oldPass: '',
                showPassFlag: false,
                showPassMsg: '两次密码不一致，请重新输入'
            }
        },
        computed: {
            tipShowFlag: {
                get(){
                    // this.userData = this.$store.state.userData;
                    // if(this.userData!=null &&  this.userData.promiseFileInfoVo!=null && !! this.userData.promiseFileInfoVo){
                    //     return this.userData.promiseFileInfoVo.auditStatus;
                    // } else {
                    //     return  3;
                    // }
                  return 1;
                },
                set(){

                }

            }
        },
        created(){
            this.$store.commit('getLoginData', this.showData);
            this.showData();
        },
        methods:{
            showData(){
                this.userData = this.$store.state.userData;
                if(this.userData!=null &&  this.userData.promiseFileInfoVo!=null && !! this.userData.promiseFileInfoVo){
                    this.promiseImg = this.userData.promiseFileInfoVo.url;
                    this.tipShowFlag = this.userData.promiseFileInfoVo.auditStatus;
                }
            },
            /*显示缩略图*/
            showSmallImg(data){
                this.promiseImg = data;
                this.show();
                this.$store.commit('changeProImg', data);
            },
            acceptNot(flag){ //是否接受短信提醒
                if(this.userData!=null && this.userData.acceptNotification == flag){
                    return false;
                }
                this.$http.request({
                    url: '/account/acceptNotification',
                    method: 'put'
                }, response => {
                    if(response.data.code===200){
                        this.userData.acceptNotification = response.data.data;
                    }
                }, err => {

                });
            },
            show(){
                this.$modal.show('upload-success');
            },
            hide(){
                this.$modal.hide('upload-success');
            },
            showMobile(){
                this.$modal.show('changeMobile-step1');
            },
            hideMobile(){
                this.$modal.hide('changeMobile-step1');
            },
            validPass(){
              if(this.newPass !==this.password && this.newPass.length  && this.password.length){
                  this.showPassFlag = true;
              }else {
                  this.showPassFlag = false;
              }
            },
            getBase(){
                this.baseInfo = true;
                this.changePass = false;
            },
            getChange(){
                this.baseInfo = false;
                this.changePass = true;
            },
            listenChangeMobile(data){
//                console.log(data);
                if(data){
                    data = data.substring(0,3) +'****' + data.substring(7);
                }
                this.userData.phone = data;
                this.$store.commit('setPhone', data);
            },
            changeNewPass(){
                this.$validator.validateAll().then(result => {
                    if(result && !this.showPassFlag) {
                        this.$http.request({
                            url: `/account/changePwdByOld?oldPwd=${this.oldPass}&newPwd=${this.password}`,
                            method: 'put'
                        }, response => {
                            if(response.data.code === 200 && response.data.data) {
                                this.$store.commit('msg','密码修改成功');
                                this.$store.commit('setLogin', false);
                                this.$store.commit('setLoginData', null);
                                this.$router.push('/login');
                            }
                        },err => {

                        })
                    }
                });
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    @import "../../assets/css/common/center";
    .label-for-file{
        color: $btn_408;
    }
.layout_n{
    margin-top:30px;
    margin-bottom: 50px;
    .center_page_wrap{
        padding: 50px 38px;
        height: 861px;
       @include bgff;
        .sub-menu-wrap{
            @include subMenu;
            margin-top:50px;
            margin-bottom:40px;
        }
        .base-info{
            color:$c_666;
            font-size:18px;
            letter-spacing: -0.43px;
            .item{
                margin-bottom:20px;
            }
            .info-item{
                span{
                    display: inline-block;
                }
                .name-tit{
                    width:88px;
                    text-align: right;
                    margin-right:20px;
                }
                .changePhone{
                    display: inline-block;
                    color:$btn_408;
                    cursor: pointer;
                }
            }
            .phoneTip{
                .span{
                    margin-right:20px;
                }
                .radio_wrap{
                    display: inline-block;
                    vertical-align: bottom;
                    font-size:16px;
                    .radio-item{
                        float:left;
                        margin-right:30px;
                        .radio{
                            border: 1px solid $border_bfb;
                            width:18px;
                            height:18px;
                            border-radius: 50%;
                            padding-top:3px;
                            padding-left:3px;
                           display: inline-block;
                            vertical-align: middle;
                            &.active{
                                border-color:$btn_408;
                                .rad{
                                    width:10px;
                                    height:10px;
                                    background: $btn_408;
                                    border-radius: 50%;
                                }
                            }
                        }
                        .text{
                            display: inline-block;
                            vertical-align: middle;
                        }
                    }

                }
            }
            .up-promise{
                span+span{
                    margin-left:20px;
                }
                a{
                    color:$btn_408;
                    margin-left:10px;
                }
            }
            .go-up-pro{
                color:$c_989;
                .load-wrap{
                    display: inline-block;
                }
            }
        }
        .change-pass{
            .filed{
                font-size:18px;
                margin-bottom:30px;
                label{
                    width:98px;
                    text-align: right;
                    margin-right:10px;
                    display: inline-block;
                    color:$c_666;
                }
                .input_wrap{
                    font-size: $c_3c3;
                    display: inline-block;
                    width:250px;
                    height:40px;
                    border:1px solid $border_bfb;
                    position: relative;
                    input{
                        line-height:18px;
                        padding: 5px 0;
                        text-indent: 10px;
                        width:100%;
                        height:100%;
                    }
                    .err{
                        position: absolute;
                        left:0;
                        top:40px;
                        width:100%;
                        font-size:14px;
                    }
                }
            }

            .btn{
                margin-top:50px;
                height:50px;
                width:204px;
                background: $btn_408;
                color:#fff;
                font-size:18px;
                line-height: 50px;
                text-align:center;
                margin-left:115px;
                button{
                    color:#fff;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/user/center.vue